  import React from "react";
  import Home from "./components/home";
  import Form from "./components/form";
  import RevibeForm from "./components/Revibe/RevibeForm";
  import ThankYou from "./components/ThankYou";
  import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
  import ScrollToTop from "./components/ScrollToTop";
  import Landing from "./components/landing";
  import RevibeLandingPage from "./components/RevibeLandingPage";
  import RevibeThankYou from "./components/Revibe/RevibeThankYou";
  import AboutPage from "./components/AboutPage";
  import PrivacyPolicy from "./components/PrivacyPolicy";
  import RefundPolicy from "./components/RefundPolicy";
 
  function App() {
    return (
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/register-form" element={<Form />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/revibe" element={<RevibeLandingPage />} />
          <Route path="/revibe-registration-form" element={<RevibeForm />} />
          <Route path="/revibe-thankyou" element={<RevibeThankYou />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          {/* <Route path="/landing" element={<Landing />} /> */}
        </Routes>
      </Router>
    );
  }

  export default App;
